import {PeopleSearchMethodologyType} from "@app/models/form/people-search-methodology-type.model";

export class OtherPersons{

  involvesPeople: boolean;
  targetAudiences:string;
  hasExplicitConsent: boolean;
  isMentionningConfidentialityAndAnonymity: boolean;
  privacyMeasuresExplanation:string;
  searchStartDate:Date;
  searchEndDate:Date;
  methodologyTypes: PeopleSearchMethodologyType[];
  otherMethodology: string;

}
